module.exports = __webpack_public_path__ + "static/cortex-about-bugz-min-46a26d3aed1cc0b009456a728c84e616.png";